
import util from "../../util";
import face from "@/assets/img/face.png";
import bindCard from "@/assets/img/bindCard_icon.png";
import editPwd from "@/assets/img/editPwd_icon.png";
import lostCard from "@/assets/img/lostCard_icon.png";
import read_report_icon from "@/assets/img/read_report_icon.png"; 
import wx_card from "@/assets/img/wx_card.png";
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import BScroll from "better-scroll";
import Cookies from "js-cookie";

let triggerTimes = 0;

export default {
name: "Person",
components: {
Flexbox,
FlexboxItem
},
data() {
return {
imgObj: {
face,
bindCard,
editPwd,
lostCard,
read_report_icon,
wx_card
},
readerName: "",
readerType: "",
readerType_show: false,
dzzhao: "",
effDate: "",
status: "",
availBook: "--",
hasBorrowBook: "--",
arrearage: "--",
bscroll: "",
isWXClient: util.isWXClient() && Cookies.get("code"),
loginTxt: "证(解)绑定",
hasCardID: false
};
},
mounted() {
this.getUserInfo();
this.initScroll();
if (this.isWXClient) {
this.initWx();
}
},
methods: {
triggerDebugger() {
triggerTimes += 1;
if (triggerTimes >= 10) {
triggerTimes = 0;
let showDebugger = JSON.parse(localStorage.getItem("debugger"));
localStorage.setItem("debugger", !showDebugger);
if (!showDebugger === false) {
alert("调试已关闭,请刷新页面");
} else {
alert("调试已开启,请刷新页面");
}
}
},
goToReportPage() {
let dzzhao = Cookies.get("dzzhao");
let token = Cookies.get("token");
if (!dzzhao) {
this.$router.push({ path: "/cardBind", query: { type: 1 } });
return;
}
window.location.href =
window.location.origin +
"/personReport/index.html?dzzhao=" +
dzzhao +
"&token=" +
token;
},
initWx() {

this.$http("post", "/user/qrCode", {
url: location.href
}).then(response => {
let res = response.data;

wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.appId, // 必填，公众号的唯一标识
timestamp: res.timestamp, // 必填，生成签名的时间戳
nonceStr: res.nonceStr, // 必填，生成签名的随机串
signature: res.signature, // 必填，签名
jsApiList: [
"checkJsApi",
"scanQRCode",
"hideMenuItems",
"addCard",
"chooseCard",
"hideMenuItems",
"openCard"
] // 必填，需要使用的JS接口列表
});
this.signature = res.signature;
this.getConfig = true;

this.$http("post", "/user/card", {
token: Cookies.get("token"),
code: Cookies.get("code"),
openId: Cookies.get("openId")
}).then(res => {
if (res.code == 0) {
if (res.data) {
this.hasCardID = true;
this.cardId = res.data;
}
}
});
});
},
addWXCard() {
this.$http("get", "/user/apiSignature", {
token: Cookies.get("token"),
code: Cookies.get("code"),
openId: Cookies.get("openId")
}).then(response => {
let res = response.data;
let requestObj = {
code: this.dzzhao,
timestamp: res.timestamp,
nonce_str: res.nonceStr,
signature: res.signature
};

wx.addCard({
cardList: [
{
cardId: this.cardId,
cardExt: JSON.stringify(requestObj)
}
], // 需要添加的卡券列表
success: function(res) {

console.log(res);

}
});
});
},
initScroll() {
if (!this.bscroll) {
let wrapper = document.querySelector(".p-person");
this.bscroll = new BScroll(wrapper, {
click: true,
bounce: {
top: false,
bottom: false,
left: false,
right: false
}
});
} else {
this.bscroll.refresh();
}
},
goToCardPage() {
let type = new String();
type = Cookies.get("openId") ? 2 : 1;
this.$router.push({ path: "/cardBind", query: { type } });
},
getUserInfo() {
this.$http("post", "/user/info", {
openId: Cookies.get("openId")
}).then(res => {
if (res.code == 2000) {
return;
}
var reader = res.data[0];
this.readerName = reader["姓名"];
this.readerType = reader["类型"];
this.readerType_show = true;
this.dzzhao = reader["读者证"];
this.effDate = reader["有效期"];
this.status = reader["状态"];
this.availBook = reader["可借册数"] - reader["已借册数"];
this.hasBorrowBook = reader["已借册数"];
this.arrearage = reader["欠费"];
});
},
handleLogout() {
const _this = this; 
this.$vux.confirm.show({
content: "是否退出登录?",
onConfirm() {
_this.$vux.loading.show();
_this
.$http("post", "/user/unBinding")
.then(() => {
_this.$vux.loading.hide();
Cookies.remove("openId");
Cookies.remove("username");
Cookies.remove("dzzhao");
util.removeLocalStorage(Cookies.get("token"));
_this.$vux.toast.show({
text: "退出登录成功"
});
_this.$router.push({
name: "Home"
});
})
.catch(() => {
_this.$vux.loading.hide();
});
}
});
}
}
};
